<div class="container font-white">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <div class="fw-semibold fs-32">Inquiry Form</div>
      <!-- <div class="fs-14 fw-normal mb-3">Fill up all your details and create a class.</div> -->
    </div>
    <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" ></div> -->
  </div>
</div>
<hr class="font-white" />

<div class="container font-white d-flex">
  <div class="flex-grow-1">
    <form>
      <!-- Error Messages -->
      @if(ErrorMsg.length > 0){
      <div AsteriskMessage [messageList]="ErrorMsg"></div>
      }
      <div>
        <div class="row g-3">
          <div class="col-md-4 col-12 mt-4">
            <label for="firstName" class="fs-14 fw-normal font-white">First Name <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.FirstName" maxlength="45" name="firstName" placeholder="FirstName" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="middleName" class="fs-14 fw-normal font-white">Middle Name</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.MiddleName" maxlength="45" name="middleName" placeholder="MiddleName" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="lastName" class="fs-14 fw-normal font-white">Last Name <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.LastName" maxlength="45" name="lastName" placeholder="LastName" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="dateOfBirth" class="fs-14 fw-normal font-white">Date of Birth <span class="text-danger">*</span></label>
            <input
              class="form-control bg-form-control border-0 font-white"
              type="date"
              [(ngModel)]="inquryDetails.DateOfBirth"
              (ngModelChange)="calculateAge()"
              name="dateOfBirth"
              placeholder="Date of Birth" />
          </div>
          <div class="col-md-4 col-12">
            <label class="fs-14 fw-normal font-white mb-2" for="gender">Gender <span class="text-danger">*</span></label>
            <div class="d-flex gap-3">
              <label class="gender-option" *ngFor="let gender of genders">
                <input type="radio" name="gender" [(ngModel)]="inquryDetails.Gender" [value]="gender" />
                <div class="circle">
                  <span *ngIf="gender === gender">✔</span>
                </div>
                <span class="gender-label" [class.active]="gender === gender">
                  {{ gender.toUpperCase() }}
                </span>
              </label>
            </div>
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="mobileNo" class="fs-14 fw-normal font-white">Mobile Number <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.MobileNo" maxlength="10" name="mobileNo" placeholder="MobileNumber" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="email" class="fs-14 fw-normal font-white">Email</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.Email" maxlength="45" name="email" placeholder="Email" />
          </div>

          <div class="col-md-2 col-12 mt-4">
            <label for="height" class="fs-14 fw-normal font-white">Height (in CM)<span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" maxlength="3" [(ngModel)]="inquryDetails.Height" type="text" name="height" placeholder="Height" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="weight" class="fs-14 fw-normal font-white">Weight (in KG)<span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" maxlength="3" [(ngModel)]="inquryDetails.Weight" type="text" name="weight" placeholder="Weight" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="age" class="fs-14 fw-normal font-white">Age</label>
            <input class="form-control bg-form-control border-0 font-white w-100" readonly [(ngModel)]="inquryDetails.Age" type="text" name="age" placeholder="Age" />
          </div>

          <div class="col-md-2 col-12 mt-4">
            <label for="experienceLevel" class="fs-14 fw-normal font-white">Experience Level</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.ExperienceLevel" type="text" name="experienceLevel" placeholder="ExperienceLevel" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="preferredBatchTime" class="fs-14 fw-normal font-white">Preferred Batch Time</label>
            <input
              class="form-control bg-form-control border-0 font-white w-100"
              [(ngModel)]="inquryDetails.PreferredBatchTime"
              type="text"
              name="preferredBatchTime"
              placeholder="PreferredBatchTime" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="preferredDays" class="fs-14 fw-normal font-white">Preferred Days</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.PreferredDays" type="text" name="preferredDays" placeholder="PreferredDays" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="medicalCondition" class="fs-14 fw-normal font-white">Medical Condition</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.MedicalCondition" type="text" name="medicalCondition" placeholder="MedicalCondition" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <label for="enquirySource" class="fs-14 fw-normal font-white">Enquiry Source</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.EnquirySource" maxlength="45" name="enquirySource" placeholder="EnquirySource" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="pincode" class="fs-14 fw-normal font-white">Pincode<span class="text-danger">*</span></label>
            <input
              class="form-control bg-form-control border-0 font-white w-100"
              [(ngModel)]="inquryDetails.Pincode"
              maxlength="6"
              name="pincode"
              (blur)="getAddressByPincode(inquryDetails.Pincode)"
              placeholder="Pincode" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="city" class="fs-14 fw-normal font-white">City<span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.City" maxlength="45" name="city" placeholder="City" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="state" class="fs-14 fw-normal font-white">State<span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.State" maxlength="45" name="state" placeholder="State" />
          </div>

          <div class="col-md-4 col-12 mt-4">
            <label for="referenceName" class="fs-14 fw-normal font-white">Reference Name</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.ReferenceName" maxlength="45" name="referenceName" placeholder="ReferenceName" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="counsellorName" class="fs-14 fw-normal font-white">Counsellor Name</label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.CounsellorName" maxlength="45" name="counsellorName" placeholder="CounsellorName" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="centerName" class="fs-14 fw-normal font-white">Center Name<span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="inquryDetails.CenterName" maxlength="45" name="centerName" placeholder="CenterName" />
          </div>
        </div>
      </div>
      <div class="mt-4 d-flex gap-3 justify-content-end">
        <!-- <button type="submit" class="close-btn px-4 py-2">Cancel</button> -->

        <button type="submit" class="add-btn px-4 py-2" (click)="onSubmit()">Submit</button>
      </div>
    </form>
  </div>
</div>
